import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxInput from "src/components/input/SfxInput.vue"
import { computed, ref } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTextarea',
  props: {
  titled: { type: Boolean, default: false },
},
  setup(__props, { expose: __expose }) {

const props = __props

//endregion

//region Variables

const inputRef = ref<typeof SfxInput | null>(null)

const classes = computed(() => ({
  "sfx-textarea--titled": props.titled,
}))

//endregion

//region Functions

function validate() {
  return inputRef.value?.validate()
}

//endregion

//region Setup Code

__expose({ validate })

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxInput, {
    ref_key: "inputRef",
    ref: inputRef,
    autogrow: "",
    class: _normalizeClass(["sfx-textarea", classes.value]),
    type: "textarea",
    rows: "1"
  }, null, 8, ["class"]))
}
}

})